import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=244ef970"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('244ef970')) {
      api.createRecord('244ef970', component.options)
    } else {
      api.reload('244ef970', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=244ef970", function () {
      api.rerender('244ef970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/coupon/edit.vue"
export default component.exports